import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { x, useTheme } from '@xstyled/styled-components';
import { th } from '@xstyled/styled-components';
import { Icon } from '../Icon';
import { IconWrap, LinkWrapper, StyledAlert, VerticalSeparator, Text, Title, CloseBtn, ActionButton, Description } from './styles';
var alertBackgroundColor = {
    success: 'green10',
    info: 'blue10',
    warning: 'yellow10',
    danger: 'red10',
};
var alertColorFill = {
    success: 'successColor',
    info: 'blue60',
    warning: 'yellow70',
    danger: 'dangerColor',
};
var alertIconMap = {
    success: 'circleCheck',
    info: 'info',
    warning: 'circleTriangle',
    danger: 'circleTriangle',
};
var Alert = function (props) {
    var intent = props.intent, inline = props.inline, onClick = props.onClick, onClose = props.onClose, title = props.title, text = props.text, href = props.href, actionLabel = props.actionLabel, actionType = props.actionType, desc = props.desc, _a = props.closeAnywhere, closeAnywhere = _a === void 0 ? false : _a;
    var theme = useTheme();
    var bgColor = th.color(intent ? alertBackgroundColor[intent] : 'transparent')({ theme: theme });
    var colorFill = th.color(intent ? alertColorFill[intent] : 'transparent')({ theme: theme });
    var icon = intent && alertIconMap[intent];
    return (_jsxs(StyledAlert, { "$bgColor": bgColor, "$colorFill": colorFill, "$inline": inline, onClick: closeAnywhere ? onClose : undefined, children: [_jsxs(x.div, { display: "flex", alignItems: "center", children: [inline && _jsx(VerticalSeparator, { "$colorFill": colorFill }), icon && (_jsx(IconWrap, { children: _jsx(Icon, { icon: icon, size: "20px", fill: colorFill }) })), _jsxs("div", { children: [_jsx(Title, { children: title }), _jsxs(Text, { children: [" ", text] })] })] }), _jsxs(x.div, { display: "flex", alignItems: "center", children: [href && actionType === 'link' && (_jsx(LinkWrapper, { "$colorFill": colorFill, to: href, children: actionLabel !== null && actionLabel !== void 0 ? actionLabel : 'Link' })), onClick && actionType === 'button' && (_jsx(ActionButton, { "$colorFill": colorFill, onClick: onClick, children: actionLabel !== null && actionLabel !== void 0 ? actionLabel : 'Submit' })), onClose && !closeAnywhere && (_jsx(CloseBtn, { onClick: onClose, children: _jsx(Icon, { icon: "close", size: "15px", fill: "gray" }) })), desc && _jsx(Description, { children: desc })] })] }));
};
export default Alert;
